import { __assign, __awaiter, __extends, __generator, __read, __spreadArray } from "tslib";
import { AddToCartActionOption, APP_DEFINITION_ID, CartEvents } from '@wix/wixstores-client-core';
import { MiniCartEvents, SecondaryEvents, SPECS } from '../../constants';
import { createClient } from '@wix/sdk/client';
import * as currentCartV1 from '@wix/auto_sdk_ecom_current-cart';
import * as currentCart from '@wix/auto_sdk_ecom_current-cart-v-2';
import { getLeanGQLCartFromCart } from './getLeanGQLCartFromCart';
import { getLeanGQLCartFromCartV1 } from './getLeanGQLCartFromCartV1';
import { BIService } from '../../apis/BIService';
import { AnalyticsService } from '../../apis/AnalyticsService';
import { deserialize, serialize } from './serialize';
import { getSDKAuthAndHost } from '../getSDKAuthAndHost';
import { ViewerStorage } from '../viewer-storage/ViewerStorage';
import { getCurrencyHeader } from '../../utils/headers';
var CACHE_KEY = 'CURRENT_CART';
var CACHE_KEY_V1 = 'CURRENT_CART_V1';
var origin = 'current-cart-service';
var BaseCurrentCartService = /** @class */ (function () {
    function BaseCurrentCartService(_a) {
        var context = _a.context, apis = _a.apis;
        this.callbacks = [];
        this.apis = apis;
        this.siteStore = context.siteStore;
        this.context = context;
    }
    BaseCurrentCartService.prototype.onChange = function (callback) {
        this.callbacks.push(callback);
    };
    BaseCurrentCartService.prototype.runCallbacks = function (options) {
        this.callbacks.forEach(function (callback) { return callback(options); });
    };
    return BaseCurrentCartService;
}());
export { BaseCurrentCartService };
var CurrentCartService = /** @class */ (function (_super) {
    __extends(CurrentCartService, _super);
    function CurrentCartService(props) {
        var _this = _super.call(this, props) || this;
        _this.shouldRefetchOnNextGet = false;
        _this.stopListeningToInstanceChanged = false;
        if (_this.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents)) {
            _this.viewerStorage = new ViewerStorage({
                cacheKey: CACHE_KEY,
                storage: _this.apis.storage,
                siteStore: _this.siteStore,
            });
        }
        else {
            _this.viewerStorageV1 = new ViewerStorage({
                cacheKey: CACHE_KEY_V1,
                storage: _this.apis.storage,
                siteStore: _this.siteStore,
            });
        }
        _this.biService = new BIService({ siteStore: _this.siteStore, origin: origin });
        _this.analyticsService = new AnalyticsService({ siteStore: _this.siteStore });
        var wixClient = createClient(__assign(__assign({}, getSDKAuthAndHost(_this.siteStore)), { modules: {
                currentCart: {
                    getCurrentCart: currentCart.getCurrentCart,
                    removeLineItemsFromCurrentCart: currentCart.removeLineItemsFromCurrentCart,
                    addCouponToCurrentCart: currentCart.addCouponToCurrentCart,
                    removeCouponFromCurrentCart: currentCart.removeCouponFromCurrentCart,
                    addLineItemsToCurrentCart: currentCart.addLineItemsToCurrentCart,
                    updateLineItemsInCurrentCart: currentCart.updateLineItemsInCurrentCart,
                    calculateCurrentCart: currentCart.calculateCurrentCart,
                    estimateCurrentCart: currentCart.estimateCurrentCart,
                    setDeliveryMethodForCurrentCart: currentCart.setDeliveryMethodForCurrentCart,
                    updateCurrentCart: currentCart.updateCurrentCart,
                    removeGiftCardFromCurrentCart: currentCart.removeGiftCardFromCurrentCart,
                    addGiftCardToCurrentCart: currentCart.addGiftCardToCurrentCart,
                    refreshCurrentCart: currentCart.refreshCurrentCart,
                    updateFormSubmissionsInCurrentCart: currentCart.updateFormSubmissionsInCurrentCart,
                },
                currentCartV1: {
                    getCurrentCart: currentCartV1.getCurrentCart,
                    estimateCurrentCartTotals: currentCartV1.estimateCurrentCartTotals,
                    addToCurrentCart: currentCartV1.addToCurrentCart,
                    updateCurrentCart: currentCartV1.updateCurrentCart,
                    updateCurrentCartLineItemQuantity: currentCartV1.updateCurrentCartLineItemQuantity,
                    removeCouponFromCurrentCart: currentCartV1.removeCouponFromCurrentCart,
                    removeLineItemsFromCurrentCart: currentCartV1.removeLineItemsFromCurrentCart,
                    createCheckoutFromCurrentCart: currentCartV1.createCheckoutFromCurrentCart,
                },
            } }));
        _this.currentCartApiV1 = wixClient.currentCartV1;
        _this.currentCartApi = wixClient.currentCart;
        return _this;
    }
    CurrentCartService.prototype.init = function () {
        if (this.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents)) {
            void this.getCurrentCart().catch(function () {
                //
            });
        }
        else {
            void this.getCurrentCartV1().catch(function () {
                //
            });
        }
        this.listenToCurrentCartEvents();
        this.listenToSecondaryCurrentCartServiceRequests();
    };
    CurrentCartService.prototype.getCurrentCartInternal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.cartPromise || this.shouldRefetchOnNextGet)) return [3 /*break*/, 3];
                        this.cartPromise = this.getCurrentCartFromCacheOrServer();
                        this.cartPromise.catch(function () {
                            _this.shouldRefetchOnNextGet = true;
                        });
                        if (!this.shouldRefetchOnNextGet) return [3 /*break*/, 3];
                        this.shouldRefetchOnNextGet = false;
                        return [4 /*yield*/, this.cartPromise];
                    case 1:
                        cart = _a.sent();
                        return [4 /*yield*/, this.notifyChange({ cart: cart })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, this.cartPromise];
                }
            });
        });
    };
    CurrentCartService.prototype.getCurrentCartV1Internal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.cartV1Promise || this.shouldRefetchOnNextGet)) return [3 /*break*/, 3];
                        this.cartV1Promise = this.getCurrentCartV1FromCacheOrServer();
                        this.cartV1Promise.catch(function () {
                            _this.shouldRefetchOnNextGet = true;
                        });
                        if (!this.shouldRefetchOnNextGet) return [3 /*break*/, 3];
                        this.shouldRefetchOnNextGet = false;
                        return [4 /*yield*/, this.cartV1Promise];
                    case 1:
                        cart = _a.sent();
                        return [4 /*yield*/, this.notifyChangeV1({ cart: cart })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, this.cartV1Promise];
                }
            });
        });
    };
    CurrentCartService.prototype.getCurrentCart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.currentCartApi.getCurrentCart()];
                    case 1:
                        cart = (_a.sent()).cart;
                        return [2 /*return*/, cart];
                    case 2: return [2 /*return*/, this.getCurrentCartInternal()];
                }
            });
        });
    };
    CurrentCartService.prototype.getCurrentCartV1 = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents)) {
                    return [2 /*return*/, this.getCurrentCartV1FromServer()];
                }
                return [2 /*return*/, this.getCurrentCartV1Internal()];
            });
        });
    };
    CurrentCartService.prototype.calculateCurrentCart = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.currentCartApi.calculateCurrentCart(options)];
            });
        });
    };
    CurrentCartService.prototype.estimateCurrentCart = function (options) {
        return this.currentCartApi.estimateCurrentCart(options);
    };
    CurrentCartService.prototype.estimateCurrentCartTotalsV1 = function (options) {
        /*istanbul ignore next */
        if (!this.currentCartApiV1) {
            throw new Error('Only supported with sdk');
        }
        return this.currentCartApiV1.estimateCurrentCartTotals(options);
    };
    CurrentCartService.prototype.invalidateAndReload = function () {
        this.shouldRefetchOnNextGet = true;
        if (this.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents)) {
            this.invalidateCurrentCartCache();
            void this.getCurrentCartInternal().catch(function () {
                //
            });
        }
        else {
            this.invalidateCurrentCartV1Cache();
            this.getCurrentCartV1Internal().catch(function () {
                //
            });
        }
        return Promise.resolve();
    };
    CurrentCartService.prototype.updateLineItemsInCurrentCart = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.currentCartApi.updateLineItemsInCurrentCart(options)];
                    case 1:
                        cart = (_a.sent()).cart;
                        return [4 /*yield*/, this.updateCache(cart)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    CurrentCartService.prototype.updateLineItemQuantityV1 = function (_a, biProps) {
        var lineItemId = _a.lineItemId, quantity = _a.quantity;
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.currentCartApiV1.updateCurrentCartLineItemQuantity([{ _id: lineItemId, quantity: quantity }])];
                    case 1:
                        cart = (_b.sent()).cart;
                        void this.biService.updateCartItemQuantityV1({ origin: biProps === null || biProps === void 0 ? void 0 : biProps.origin, cart: cart });
                        if (this.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents)) {
                            void this.invalidateAndReload();
                            return [2 /*return*/];
                        }
                        return [2 /*return*/, this.updateCacheV1(cart)];
                }
            });
        });
    };
    CurrentCartService.prototype.createCheckoutV1 = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.currentCartApiV1.createCheckoutFromCurrentCart(options)];
            });
        });
    };
    CurrentCartService.prototype.removeGiftCardFromCurrentCart = function (_a) {
        var giftCardId = _a.giftCardId;
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.currentCartApi.removeGiftCardFromCurrentCart(giftCardId)];
                    case 1:
                        cart = (_b.sent()).cart;
                        return [4 /*yield*/, this.updateCache(cart)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    CurrentCartService.prototype.addGiftCardToCurrentCart = function (_a) {
        var giftCardInput = _a.giftCardInput;
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.currentCartApi.addGiftCardToCurrentCart(giftCardInput)];
                    case 1:
                        cart = (_b.sent()).cart;
                        return [4 /*yield*/, this.updateCache(cart)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    CurrentCartService.prototype.removeLineItemsFromCurrentCart = function (_a) {
        var lineItemIds = _a.lineItemIds;
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.currentCartApi.removeLineItemsFromCurrentCart(lineItemIds)];
                    case 1:
                        cart = (_b.sent()).cart;
                        return [4 /*yield*/, this.updateCache(cart)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    CurrentCartService.prototype.removeLineItemV1 = function (_a, biProps) {
        var lineItemId = _a.lineItemId;
        return __awaiter(this, void 0, void 0, function () {
            var previousCart, cart;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getCurrentCartV1()];
                    case 1:
                        previousCart = _b.sent();
                        return [4 /*yield*/, this.currentCartApiV1.removeLineItemsFromCurrentCart([lineItemId])];
                    case 2:
                        cart = (_b.sent()).cart;
                        void this.biService.removeLineItemV1({ cart: cart, origin: biProps === null || biProps === void 0 ? void 0 : biProps.origin });
                        this.analyticsService.trackRemoveLineItemV1({ lineItemId: lineItemId, updatedCart: cart, previousCart: previousCart });
                        if (this.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents)) {
                            void this.invalidateAndReload();
                            return [2 /*return*/];
                        }
                        return [2 /*return*/, this.updateCacheV1(cart)];
                }
            });
        });
    };
    CurrentCartService.prototype.updateBuyerNoteV1 = function (_a) {
        var buyerNote = _a.buyerNote;
        return __awaiter(this, void 0, void 0, function () {
            var updatedCart;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.currentCartApiV1.updateCurrentCart({ cartInfo: { buyerNote: buyerNote } })];
                    case 1:
                        updatedCart = _b.sent();
                        if (this.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents)) {
                            void this.invalidateAndReload();
                            return [2 /*return*/];
                        }
                        return [2 /*return*/, this.updateCacheV1(updatedCart)];
                }
            });
        });
    };
    CurrentCartService.prototype.addCouponToCurrentCart = function (_a) {
        var coupon = _a.coupon;
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.currentCartApi.addCouponToCurrentCart(coupon)];
                    case 1:
                        cart = (_b.sent()).cart;
                        return [4 /*yield*/, this.updateCache(cart)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    CurrentCartService.prototype.applyCouponV1 = function (_a, biProps) {
        var code = _a.code;
        return __awaiter(this, void 0, void 0, function () {
            var updatedCart;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.currentCartApiV1.updateCurrentCart({ couponCode: code })];
                    case 1:
                        updatedCart = _b.sent();
                        void this.biService.applyCouponV1({ cart: updatedCart, couponCode: code, origin: biProps === null || biProps === void 0 ? void 0 : biProps.origin });
                        if (this.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents)) {
                            void this.invalidateAndReload();
                            return [2 /*return*/];
                        }
                        return [2 /*return*/, this.updateCacheV1(updatedCart)];
                }
            });
        });
    };
    CurrentCartService.prototype.removeCouponFromCurrentCart = function (_a) {
        var couponId = _a.couponId;
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.currentCartApi.removeCouponFromCurrentCart(couponId)];
                    case 1:
                        cart = (_b.sent()).cart;
                        return [4 /*yield*/, this.updateCache(cart)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    CurrentCartService.prototype.removeCouponV1 = function (biProps) {
        return __awaiter(this, void 0, void 0, function () {
            var appliedDiscounts, cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCurrentCartV1()];
                    case 1:
                        appliedDiscounts = (_a.sent()).appliedDiscounts;
                        return [4 /*yield*/, this.currentCartApiV1.removeCouponFromCurrentCart()];
                    case 2:
                        cart = (_a.sent()).cart;
                        void this.biService.removeCouponV1({
                            origin: biProps === null || biProps === void 0 ? void 0 : biProps.origin,
                            discounts: appliedDiscounts,
                            cart: cart,
                        });
                        if (this.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents)) {
                            void this.invalidateAndReload();
                            return [2 /*return*/];
                        }
                        return [2 /*return*/, this.updateCacheV1(cart)];
                }
            });
        });
    };
    CurrentCartService.prototype.setAddressV1 = function (_a) {
        var address = _a.address;
        return __awaiter(this, void 0, void 0, function () {
            var country, subdivision, zipCode, cart;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        country = address.country, subdivision = address.subdivision, zipCode = address.zipCode;
                        return [4 /*yield*/, this.currentCartApiV1.updateCurrentCart({
                                cartInfo: {
                                    contactInfo: {
                                        address: {
                                            country: country,
                                            subdivision: subdivision !== null && subdivision !== void 0 ? subdivision : null,
                                            postalCode: zipCode !== null && zipCode !== void 0 ? zipCode : null,
                                            addressLine1: null,
                                            addressLine2: null,
                                            city: null,
                                            streetAddress: null,
                                        },
                                    },
                                },
                            })];
                    case 1:
                        cart = _b.sent();
                        if (this.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents)) {
                            void this.invalidateAndReload();
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.updateCacheV1(cart)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CurrentCartService.prototype.setDeliveryMethodForCurrentCart = function (_a) {
        var deliveryMethod = _a.deliveryMethod;
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.currentCartApi.setDeliveryMethodForCurrentCart(deliveryMethod)];
                    case 1:
                        cart = (_b.sent()).cart;
                        return [4 /*yield*/, this.updateCache(cart)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    CurrentCartService.prototype.selectShippingOptionV1 = function (_a) {
        var _b;
        var selectedShippingOption = _a.selectedShippingOption, option = _a.option;
        return __awaiter(this, void 0, void 0, function () {
            var updatedCart;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.currentCartApiV1.updateCurrentCart({
                            cartInfo: {
                                selectedShippingOption: {
                                    code: (_b = option === null || option === void 0 ? void 0 : option.code) !== null && _b !== void 0 ? _b : selectedShippingOption.optionId,
                                    carrierId: option === null || option === void 0 ? void 0 : option.carrierId,
                                },
                            },
                        })];
                    case 1:
                        updatedCart = _c.sent();
                        if (this.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents)) {
                            void this.invalidateAndReload();
                            return [2 /*return*/];
                        }
                        return [2 /*return*/, this.updateCacheV1(updatedCart)];
                }
            });
        });
    };
    CurrentCartService.prototype.addLineItemsToCurrentCart = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.currentCartApi.addLineItemsToCurrentCart(options)];
                    case 1:
                        cart = (_a.sent()).cart;
                        if (!cart) {
                            throw new Error('Failed to Add Line Items To Current Cart');
                        }
                        return [4 /*yield*/, this.updateCache(cart)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    CurrentCartService.prototype.addToCurrentCartV1 = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.currentCartApiV1.addToCurrentCart(options)];
                    case 1:
                        cart = (_a.sent()).cart;
                        if (!cart) {
                            throw new Error('Failed to Add To Current Cart');
                        }
                        if (this.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents)) {
                            void this.invalidateAndReload();
                            return [2 /*return*/];
                        }
                        return [2 /*return*/, this.updateCacheV1(cart)];
                }
            });
        });
    };
    CurrentCartService.prototype.updateCurrentCart = function (cart) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedCart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.currentCartApi.updateCurrentCart(cart)];
                    case 1:
                        updatedCart = (_a.sent()).cart;
                        return [4 /*yield*/, this.updateCache(updatedCart)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, updatedCart];
                }
            });
        });
    };
    CurrentCartService.prototype.refreshCurrentCart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.currentCartApi.refreshCurrentCart()];
                    case 1:
                        cart = (_a.sent()).cart;
                        return [4 /*yield*/, this.updateCache(cart)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    CurrentCartService.prototype.notifyChange = function (_a) {
        var cart = _a.cart;
        this.runCallbacks({ revision: cart.revision });
        this.publishUpdateForSecondaryCurrentCart();
        return this.updateMiniCart(cart);
    };
    CurrentCartService.prototype.updateFormSubmissionsInCurrentCart = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.currentCartApi.updateFormSubmissionsInCurrentCart(options)];
                    case 1:
                        cart = (_a.sent()).cart;
                        return [4 /*yield*/, this.updateCache(cart)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    CurrentCartService.prototype.notifyChangeV1 = function (_a) {
        var cart = _a.cart;
        this.runCallbacks();
        this.publishUpdateForSecondaryCurrentCart();
        return this.updateMiniCartV1(cart);
    };
    CurrentCartService.prototype.listenToSecondaryCurrentCartServiceRequests = function () {
        var _this = this;
        this.subscribeToSecondaryEvent(SecondaryEvents.GetRequest, this.getCurrentCart.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.GetV1Request, this.getCurrentCartV1.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.RefreshV1Request, this.invalidateAndReload.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.UpdateLineItemsInCurrentCartRequest, this.updateLineItemsInCurrentCart.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.UpdateQuantityV1Request, this.updateLineItemQuantityV1.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.RemoveLineItemsFromCurrentCartRequest, this.removeLineItemsFromCurrentCart.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.RemoveItemV1Request, this.removeLineItemV1.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.OnLoginStartRequest, this.onLoginStart.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.OnLoginFinishRequest, this.onLoginFinish.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.UpdateBuyerNoteV1Request, this.updateBuyerNoteV1.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.AddCouponToCurrentCartRequest, this.addCouponToCurrentCart.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.ApplyCouponV1Request, this.applyCouponV1.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.RemoveCouponFromCurrentCartRequest, this.removeCouponFromCurrentCart.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.RemoveCouponV1Request, this.removeCouponV1.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.SetAddressV1Request, this.setAddressV1.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.SetDeliveryMethodForCurrentCartRequest, this.setDeliveryMethodForCurrentCart.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.SelectShippingOptionV1Request, this.selectShippingOptionV1.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.CalculateCurrentCart, this.calculateCurrentCart.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.EstimateCurrentCart, this.estimateCurrentCart.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.EstimateCurrentCartTotalsV1, this.estimateCurrentCartTotalsV1.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.AddLineItemsToCurrentCart, this.addLineItemsToCurrentCart.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.AddToCurrentCartV1, this.addToCurrentCartV1.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.CreateCheckoutV1Request, this.createCheckoutV1.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.UpdateCurrentCartRequest, this.updateCurrentCart.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.RefreshCurrentCartRequest, this.refreshCurrentCart.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.RemoveGiftCardFromCurrentCartRequest, this.removeGiftCardFromCurrentCart.bind(this));
        this.subscribeToSecondaryEvent(SecondaryEvents.AddGiftCardToCurrentCartRequest, this.addGiftCardToCurrentCart.bind(this));
        this.apis.pubSub.subscribe(SecondaryEvents.HEALTH_CHECK, function () {
            _this.apis.pubSub.publish(SecondaryEvents.ACK, {}, false);
        }, false);
        this.subscribeToSecondaryEvent(SecondaryEvents.UpdateFormSubmissionsInCurrentCartRequest, this.updateFormSubmissionsInCurrentCart.bind(this));
    };
    CurrentCartService.prototype.subscribeToSecondaryEvent = function (event, performAction) {
        var _this = this;
        this.apis.pubSub.subscribe(event, 
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        function (_a) {
            var data = _a.data;
            return __awaiter(_this, void 0, void 0, function () {
                var _b, key, payload, actionResponse, error, e_1;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _b = deserialize(data), key = _b.key, payload = _b.payload;
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, performAction.apply(void 0, __spreadArray([], __read((payload || [])), false))];
                        case 2:
                            actionResponse = _c.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            e_1 = _c.sent();
                            actionResponse = undefined;
                            error = e_1;
                            return [3 /*break*/, 4];
                        case 4:
                            this.apis.pubSub.publish(SecondaryEvents.ActionResponse, serialize({ key: key, payload: actionResponse, error: error }), false);
                            return [2 /*return*/];
                    }
                });
            });
        }, false);
    };
    // eslint-disable-next-line sonarjs/cognitive-complexity
    CurrentCartService.prototype.listenToCurrentCartEvents = function () {
        var _this = this;
        var currency = this.siteStore.location.query.currency;
        this.siteStore.location.onChange(function () {
            if (currency !== _this.siteStore.location.query.currency) {
                currency = _this.siteStore.location.query.currency;
                void _this.invalidateAndReload();
            }
        });
        this.siteStore.pubSubManager.subscribe(CartEvents.CLEARED, function (res) { return void _this.clearCart(res.data.cartId); });
        this.siteStore.pubSubManager.subscribe(CartEvents.INVALIDATED, function () {
            if (_this.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents)) {
                _this.invalidateCurrentCartCache();
            }
            else {
                _this.invalidateCurrentCartV1Cache();
            }
        });
        this.siteStore.siteApis.onInstanceChanged(function () {
            if (_this.stopListeningToInstanceChanged) {
                return;
            }
            void _this.invalidateAndReload();
        }, APP_DEFINITION_ID);
        this.siteStore.pubSubManager.subscribe(MiniCartEvents.LoadedWithoutData, function () {
            if (_this.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents)) {
                _this.getMiniCartLeanModel().then(function (cart) {
                    _this.siteStore.pubSubManager.publish(MiniCartEvents.OnInitialData, cart);
                });
            }
            else {
                _this.getMiniCartLeanModelV1().then(function (cart) {
                    _this.siteStore.pubSubManager.publish(MiniCartEvents.OnInitialData, cart);
                });
            }
        });
    };
    CurrentCartService.prototype.onLoginStart = function () {
        this.stopListeningToInstanceChanged = true;
        return Promise.resolve();
    };
    CurrentCartService.prototype.onLoginFinish = function () {
        this.stopListeningToInstanceChanged = false;
        return Promise.resolve();
    };
    CurrentCartService.prototype.getMiniCartLeanModel = function (cart) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, getLeanGQLCartFromCart({
                        currentCartService: this,
                        wixApi: this.context.wixApi,
                        platformServices: this.context.platformServices,
                        cart: cart,
                    })];
            });
        });
    };
    CurrentCartService.prototype.getMiniCartLeanModelV1 = function (cart) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, getLeanGQLCartFromCartV1(this, cart)];
            });
        });
    };
    CurrentCartService.prototype.updateCache = function (cart) {
        this.cartPromise = Promise.resolve(cart);
        this.shouldRefetchOnNextGet = false;
        this.viewerStorage.set(this.toCacheEntity(cart));
        return this.notifyChange({ cart: cart });
    };
    CurrentCartService.prototype.updateCacheV1 = function (cart) {
        this.cartV1Promise = Promise.resolve(cart);
        this.shouldRefetchOnNextGet = false;
        this.viewerStorageV1.set(this.toCacheEntity(cart));
        return this.notifyChangeV1({ cart: cart });
    };
    CurrentCartService.prototype.toCacheEntity = function (cart) {
        return {
            cart: cart,
            currency: getCurrencyHeader(this.siteStore.wixCodeApi),
            multiLang: this.siteStore.getMultiLangHeader(),
        };
    };
    CurrentCartService.prototype.invalidateCurrentCartV1Cache = function () {
        this.viewerStorageV1.remove();
    };
    CurrentCartService.prototype.invalidateCurrentCartCache = function () {
        this.viewerStorage.remove();
    };
    CurrentCartService.prototype.publishUpdateForSecondaryCurrentCart = function () {
        this.siteStore.pubSubManager.publish(SecondaryEvents.Updated, {});
    };
    CurrentCartService.prototype.updateMiniCart = function (cart) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _b = (_a = this.siteStore.pubSubManager).publish;
                        _c = [CartEvents.CHANGED];
                        _d = [{}];
                        return [4 /*yield*/, this.getMiniCartLeanModel(cart)];
                    case 1:
                        _b.apply(_a, _c.concat([__assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_e.sent())])), { extraParams: { origin: 'CurrentCartUpdate' }, eventOptions: {
                                        shouldOpenCart: false,
                                        addToCartActionOption: AddToCartActionOption.MINI_CART,
                                        originatedInWorker: true,
                                    }, reason: 'CurrentCartUpdate' }])]));
                        return [2 /*return*/];
                }
            });
        });
    };
    CurrentCartService.prototype.updateMiniCartV1 = function (cart) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _b = (_a = this.siteStore.pubSubManager).publish;
                        _c = [CartEvents.CHANGED];
                        _d = [{}];
                        return [4 /*yield*/, this.getMiniCartLeanModelV1(cart)];
                    case 1:
                        _b.apply(_a, _c.concat([__assign.apply(void 0, [__assign.apply(void 0, _d.concat([(_e.sent())])), { extraParams: { origin: 'CurrentCartUpdate' }, eventOptions: {
                                        shouldOpenCart: false,
                                        addToCartActionOption: AddToCartActionOption.MINI_CART,
                                        originatedInWorker: true,
                                    }, reason: 'CurrentCartUpdate' }])]));
                        return [2 /*return*/];
                }
            });
        });
    };
    CurrentCartService.prototype.clearCart = function (givenCartId) {
        return __awaiter(this, void 0, void 0, function () {
            var id, cart, cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getCurrentCart()];
                    case 1:
                        id = (_a.sent())._id;
                        if (!(givenCartId === id)) return [3 /*break*/, 3];
                        cart = { lineItems: [] };
                        this.cartPromise = Promise.resolve(cart);
                        this.shouldRefetchOnNextGet = false;
                        return [4 /*yield*/, this.notifyChange({ cart: cart })];
                    case 2:
                        _a.sent();
                        this.invalidateCurrentCartCache();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 7];
                    case 4: return [4 /*yield*/, this.getCurrentCartV1()];
                    case 5:
                        id = (_a.sent())._id;
                        if (!(givenCartId === id)) return [3 /*break*/, 7];
                        cart = { lineItems: [] };
                        this.cartV1Promise = Promise.resolve(cart);
                        this.shouldRefetchOnNextGet = false;
                        return [4 /*yield*/, this.notifyChangeV1({ cart: cart })];
                    case 6:
                        _a.sent();
                        this.invalidateCurrentCartV1Cache();
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    CurrentCartService.prototype.getCurrentCartIdFromCache = function () {
        var cached = this.viewerStorage.get();
        if (cached && this.isCachedCartValid(cached)) {
            return cached.cart._id;
        }
        return undefined;
    };
    CurrentCartService.prototype.getCurrentCartFromCacheOrServer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cached, cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.shouldRefetchOnNextGet) {
                            cached = this.viewerStorage.get();
                            if (cached && this.isCachedCartValid(cached)) {
                                return [2 /*return*/, cached.cart];
                            }
                        }
                        return [4 /*yield*/, this.getCurrentCartFromServer()];
                    case 1:
                        cart = (_a.sent());
                        this.viewerStorage.set(this.toCacheEntity(cart));
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    CurrentCartService.prototype.getCurrentCartV1FromCacheOrServer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cart, cachedCart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.shouldRefetchOnNextGet) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getCurrentCartV1FromServer()];
                    case 1:
                        cart = _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        cachedCart = this.viewerStorageV1.get();
                        if (cachedCart && this.isCachedCartValid(cachedCart)) {
                            return [2 /*return*/, cachedCart.cart];
                        }
                        return [4 /*yield*/, this.getCurrentCartV1FromServer()];
                    case 3:
                        cart = _a.sent();
                        _a.label = 4;
                    case 4:
                        this.viewerStorageV1.set(this.toCacheEntity(cart));
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    CurrentCartService.prototype.isCachedCartValid = function (cachedCart) {
        return (!this.siteStore.experiments.enabled(SPECS.UseSessionStorageForCartCache) ||
            (cachedCart.currency === getCurrencyHeader(this.siteStore.wixCodeApi) &&
                cachedCart.multiLang === this.siteStore.getMultiLangHeader()));
    };
    CurrentCartService.prototype.getCurrentCartFromServer = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var cart, e_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.currentCartApi.getCurrentCart()];
                    case 1:
                        cart = (_c.sent()).cart;
                        return [2 /*return*/, cart];
                    case 2:
                        e_2 = _c.sent();
                        /*istanbul ignore next */
                        if (((_b = (_a = e_2 === null || e_2 === void 0 ? void 0 : e_2.details) === null || _a === void 0 ? void 0 : _a.applicationError) === null || _b === void 0 ? void 0 : _b.code) === 'CURRENT_CART_NOT_FOUND') {
                            return [2 /*return*/, { lineItems: [] }];
                        }
                        throw e_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CurrentCartService.prototype.getCurrentCartV1FromServer = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.currentCartApiV1.getCurrentCart()];
                    case 1: return [2 /*return*/, _c.sent()];
                    case 2:
                        e_3 = _c.sent();
                        /*istanbul ignore next */
                        if (((_b = (_a = e_3 === null || e_3 === void 0 ? void 0 : e_3.details) === null || _a === void 0 ? void 0 : _a.applicationError) === null || _b === void 0 ? void 0 : _b.code) === 'OWNED_CART_NOT_FOUND') {
                            return [2 /*return*/, { lineItems: [] }];
                        }
                        throw e_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return CurrentCartService;
}(BaseCurrentCartService));
export { CurrentCartService };
//# sourceMappingURL=CurrentCartService.js.map